import React, { useEffect, useState, useCallback } from "react";
import {
  Card,
  Col,

  Row,
  DatePicker,
  Typography,
  Select,
  Space,

  Button,
  Form,
  Modal,
  Collapse,
  Divider,
} from "antd";
import dayjs from "dayjs";
import { TraitementService } from "../Services/TraitementService";
import { ReportingExportService } from "../Services/ReportingExportService";
import * as XLSX from "xlsx";
import DocumentForm from "./DocumentForm";

import { FileSearchOutlined } from "@ant-design/icons";
import "../Pages/CSS/Traitement.css";
const { Meta } = Card;
const { RangePicker } = DatePicker;
const { Option } = Select;
const { Title, Text } = Typography;
const { Panel } = Collapse;
const getSelectedYear = () => {
  const currentYear = new Date().getFullYear();
  return currentYear.toString();
};

const ReportExport = () => {
  const [selectedYear, setSelectedYear] = useState(null);
  const [exercices, setExercices] = useState([]);
  const [refetch, setRefetch] = useState(null);
  const [modalContent, setModalContent] = useState({});
  const [dateDeb, setDateDeb] = useState(null);
  const [dateFin, setDateFin] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [loadingExport, setLoadingExport] = useState(false);

  const traitementFactureService = new TraitementService();
  const reportingExportService = new ReportingExportService();

  const [form] = Form.useForm();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const exercicesData = await traitementFactureService.getExercices();
        setExercices([...exercicesData].sort((a, b) => b - a));
        const paramData = await traitementFactureService.getParamComptable();
        const yearFromParamData = dayjs(paramData.datedeb).format("YYYY");
        setSelectedYear(yearFromParamData)
      } catch (error) {
        console.error("Erreur lors de la récupération des données :", error);
      }
    };

    fetchData();
  }, []);
  useEffect(() => {
    if (selectedYear) {
      setDateDeb(new Date(parseInt(selectedYear), 0, 1));
      setDateFin(new Date(parseInt(selectedYear), 11, 31));
    }
  }, [selectedYear]);

  const showModal = (type) => {
    setModalContent(type);
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleYearChange = (value) => {
    setSelectedYear(value);
    setDateDeb(new Date(value, 0, 1));
    setDateFin(new Date(value, 11, 31));
    setRefetch(Date.now());
  };
  const exportToExcel = (data, exportName) => {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(workbook, `${exportName}.xlsx`);
  };

  const handleExport = async (codeExport, exportName) => {
    const payload = {
      codeExport: codeExport,
      dateDeb: dateDeb.toISOString().slice(0, 10),
      dateFin: dateFin.toISOString().slice(0, 10),
    };

    try {
      const result = await reportingExportService.exportAllReport(payload);
      console.log("Résultat de l'export:", result);

      // Tri décroissant des données en fonction du champ 'debit'
      const sortedResult = result.sort((a, b) => b.debit - a.debit);

      exportToExcel(sortedResult, exportName);
    } catch (error) {
      console.error("Erreur lors de l'exportation:", error);
    }
  };



  const handlePrintPDF = (codeExport) => {
    const formData = form.getFieldsValue();
    const dateDebFormat = dateDeb.toISOString().slice(0, 10);
    const dateFinFormat = dateFin.toISOString().slice(0, 10);
    const codesoc = formData.soc
    reportingExportService.printAllService(
      codeExport === "21" && codesoc === 'all' ? "211" : codeExport,
      dateDebFormat,
      dateFinFormat,
      codesoc,
    );
  };

  const resetFieldsOnClose = useCallback(() => {
    form.resetFields();
  }, [form]);

  const exportDonnée = async () => {
    setLoadingExport(true);
    try {
      const formData = await form.validateFields();
      console.log("Données à exporter:", formData);

      let payload = {};
      let fileName = "export";

      switch (modalContent) {
        case "Nombre de Documents":
          payload = {
            codeExport: "51",
            compte: formData.compte || "all",
            dateDeb: dateDeb.toISOString().slice(0, 10),
            dateFin: dateFin.toISOString().slice(0, 10),
            part: formData.part || "all",
            fourn: formData.fourn || "all",
            soc: formData.soc || "all",
            typeBenef: formData.typeBenef || "all",
            presc: "all",
          };
          fileName = "Nombre_De_Documents";
          break;

        case "Charges Techniques VS Cotisations":
          payload = {
            codeExport: "21",
            dateDeb: dateDeb.toISOString().slice(0, 10),
            dateFin: dateFin.toISOString().slice(0, 10),
            codesoc: formData.soc || "all",
          };
          fileName = "Charges_Techniques_VS_Cotisations";
          break;

        case "Charges Techniques":
          payload = {
            codeExport: "11",
            compte: formData.compte || "all",
            dateDeb: dateDeb.toISOString().slice(0, 10),
            dateFin: dateFin.toISOString().slice(0, 10),
            codesoc: formData.codesoc || "all",
            part: formData.part || "all",
            fourn: formData.fourn || "all",
            presc: "all",
          };
          fileName = "Charges_Techniques";
          break;
        case "Recherche Population Sociale":
          payload = {
            codeExport: "61",
            sexe: formData.sexe,
            age: formData.age,
            typeBenef: formData.typeBenef || "all",
            localite: formData.localite,
          };
          fileName = "Recherche_Population_Sociale";
          break;
        default:
          break;
      }

      const result = await reportingExportService.exportAllReport(payload);
      console.log("Résultat de l'export:", result);
      exportToExcel(result, fileName);

      setIsModalVisible(false);
    } catch (error) {
      console.log("Erreur de validation:", error);
    } finally {
      setLoadingExport(false);
    }
  };


  return (
    <div style={{ padding: 12 }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 12,
          padding: "10px 20px",
          background: "linear-gradient(135deg, #1890ff 0%, #0097e6 100%)",
          borderRadius: 10,
          boxShadow: "0 4px 15px rgba(24, 144, 255, 0.3)",
          marginBottom: 16,
        }}
      >
        <FileSearchOutlined style={{ fontSize: 22, color: "#fff" }} />
        <span
          style={{
            fontSize: 18,
            fontWeight: 600,
            color: "#fff",
            letterSpacing: 0.5,
            margin: 0,
          }}
        >
          Reporting & Export
        </span>
      </div>
      <Row gutter={16} style={{ marginBottom: 16 }}>

        <Col span={16}>
          <Space direction="vertical" style={{ textAlign: "left" }}>
            <label>Exercice</label>
            <Select
              className="select-colored-accent"
              style={{
                width: 90,
                marginRight: 10,
                "--select-accent": "#1890ff",
                "--select-accent-bg": "#e6f4ff",
                "--select-accent-shadow": "rgba(24, 144, 255, 0.25)",
              }}
              onChange={handleYearChange}
              value={selectedYear}
            >
              {exercices.map((year) => (
                <Option key={year} value={year}>
                  {year}
                </Option>
              ))}
            </Select>
          </Space>
          <Space direction="vertical" style={{ textAlign: "left" }}>
            <label>Période</label>
            <RangePicker
              format="DD/MM/YYYY"
              value={[dayjs(dateDeb), dayjs(dateFin)]}
              onChange={(dates) => {
                if (dates && dates.length === 2) {
                  setDateDeb(dates[0].toDate());
                  setDateFin(dates[1].toDate());
                  setRefetch(Date.now());
                }
              }}
            />
          </Space>
        </Col>
        <Col span={8} style={{ display: "flex", justifyContent: "end" }}></Col>
      </Row>
      <Card>
        <Row gutter={16}>

          <Col span={12}>
            <Collapse style={{ marginBottom: 16 }}>
              <Panel header="Frais Réels et Charges" key="1">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <span style={{ marginRight: "8px" }}>Charges Techniques</span>
                  <Button
                    className="requeteButton"
                    onClick={() => showModal("Charges Techniques")}
                    type="ghost"
                  >
                    Requête...
                  </Button>
                </div>
                <Divider />
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <span style={{ marginRight: "8px" }}>Par Type de Bénéficiaire</span>
                  <Button.Group>
                    <Button
                      type="ghost"
                      className="buttonExport"
                      onClick={() => handleExport("12", "Type_de_Bénéficiaire")}
                    >
                      Excel
                    </Button>
                    <Button
                      className="buttonRegenere"
                      onClick={() => handlePrintPDF("12")}
                      type="ghost"
                    >
                      PDF
                    </Button>
                  </Button.Group>
                </div>
                <Divider />
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <span style={{ marginRight: "8px" }}>Par Type de Bénéficiaire / Adhérents</span>
                  <Button.Group>
                    <Button
                      className="buttonExport"
                      onClick={() => handleExport("13", "Par Prestation (Mensuels)")}
                      type="ghost"
                    >
                      Excel
                    </Button>
                    <Button
                      className="buttonRegenere"
                      onClick={() => handlePrintPDF("13")}
                      type="ghost"
                    >
                      PDF
                    </Button>
                  </Button.Group>
                </div>

              </Panel>
            </Collapse>
            <Collapse style={{ marginBottom: 16 }}>
              <Panel header="Fournisseurs de Soins" key="2">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <span style={{ marginRight: "8px" }}>Classement CA par Spécialités / Fournisseurs </span>
                  <Button.Group>
                    <Button
                      className="buttonExport"
                      onClick={() => handleExport("31", "Classement par CA")}
                      type="ghost"
                    >
                      Excel
                    </Button>
                    <Button
                      className="buttonRegenere"
                      onClick={() => handlePrintPDF("31")}
                      type="ghost"
                    >
                      PDF
                    </Button>
                  </Button.Group>

                </div>
                <Divider />

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <span style={{ marginRight: "8px" }}>Classement CA par Fournisseurs </span>
                  <Button.Group>
                    <Button
                      className="buttonExport"
                      onClick={() => handleExport("31", "Classement par CA")}
                      type="ghost"
                    >
                      Excel
                    </Button>
                    <Button
                      className="buttonRegenere"
                      onClick={() => handlePrintPDF("31")}
                      type="ghost"
                    >
                      PDF
                    </Button>
                  </Button.Group>

                </div>
              </Panel>
            </Collapse>
            <Collapse style={{ marginBottom: 16 }}>
              <Panel header="Lettres de Garantie et BC" key="3">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <span style={{ marginRight: "8px" }}>Nombre de Documents</span>
                  <Button
                    className="requeteButton"
                    onClick={() => showModal("Nombre de Documents")}
                    type="ghost"
                  >
                    Requête...
                  </Button>
                </div>
                <Divider />


                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <span style={{ marginRight: "8px" }}>Tableau Synthèse</span>
                  <Button.Group>
                    <Button
                      className="buttonExport"
                      onClick={() => handleExport("52", "Tableau Synthèse")}
                      type="ghost"
                    >
                      Excel
                    </Button>
                    <Button
                      className="buttonRegenere"
                      onClick={() => handlePrintPDF("52")}
                      type="ghost"
                    >
                      PDF
                    </Button>
                  </Button.Group>
                </div>
              </Panel>
            </Collapse>
          </Col>
          <Col span={12}>
            <Collapse style={{ marginBottom: 16 }}>
              <Panel header="Adhérents (Sociétés)" key="4">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <span style={{ marginRight: "8px" }}>Charges Techniques VS Cotisations</span>
                  <Button
                    className="requeteButton"
                    onClick={() => showModal("Charges Techniques VS Cotisations")}
                    type="ghost"
                  >
                    Requête...
                  </Button>
                </div>
                <Divider />
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <span style={{ marginRight: "8px" }}>Produits Techniques</span>
                  <Button
                    className="buttonExport"
                    onClick={() => handleExport("22", "Produits Techniques")}
                    type="ghost"
                  >
                    Excel
                  </Button>
                </div>
              </Panel>
            </Collapse>
            <Collapse style={{ marginBottom: 16 }}>
              <Panel header="Consommations" key="5">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <span style={{ marginRight: "8px" }}>
                    Consommation par ordre décroissant
                  </span>
                  <Button.Group>
                    <Button
                      className="buttonExport"
                      onClick={() =>
                        handleExport("41", " Consommation par ordre décroissant")
                      }
                      type="ghost"
                    >
                      Excel
                    </Button>
                    <Button
                      className="buttonRegenere"
                      onClick={() => handlePrintPDF("41")}
                      type="ghost"
                    >
                      PDF
                    </Button>
                  </Button.Group>
                </div>
                <Divider />
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <span style={{ marginRight: "8px" }}>
                    Consommation Hors Hospitalisation et Optique
                  </span>
                  <Button.Group>
                    <Button
                      className="buttonExport"
                      onClick={() =>
                        handleExport(
                          "42",
                          "Consommation Hors Hospitalisation et Optique"
                        )
                      }
                      type="ghost"
                    >
                      Excel
                    </Button>
                    <Button
                      className="buttonRegenere"
                      onClick={() => handlePrintPDF("42")}
                      type="ghost"
                    >
                      PDF
                    </Button>
                  </Button.Group>
                </div>
              </Panel>
            </Collapse>
            <Collapse style={{ marginBottom: 16 }}>
              <Panel header="Population Sociale" key="6">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <span style={{ marginRight: "8px" }}>Recherche</span>
                  <Button
                    className="requeteButton"
                    onClick={() => showModal("Recherche Population Sociale")}
                    type="ghost"
                  >
                    Requête...
                  </Button>
                </div>
                <Divider />
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <span style={{ marginRight: "8px" }}>Tableau Icamo</span>
                  <Button
                    className="buttonRegenere"
                    onClick={() => handlePrintPDF("62")}
                    type="ghost"
                  >
                    PDF
                  </Button>
                </div>
              </Panel>
            </Collapse>
          </Col>

        </Row>
      </Card>
      <Modal
        style={{ top: 20 }}
        title={`Requête - ${modalContent}`}
        open={isModalVisible}
        onOk={exportDonnée}
        onCancel={handleCancel}
        // okText="Exporter"
        // cancelText="Fermer"
        footer={[
          modalContent === "Charges Techniques VS Cotisations" && (
            <Button key="custom" type="primary" onClick={() => { handlePrintPDF("21") }}>
              PDF
            </Button>
          ),
          <Button key="cancel" onClick={handleCancel}>
            Fermer
          </Button>,
          <Button key="ok" type="primary" className="buttonExport" onClick={exportDonnée} loading={loadingExport}>
            Excel
          </Button>,
        ].filter(Boolean)}
      >
        <DocumentForm
          modalContent={modalContent}
          form={form}
          resetFieldsOnClose={resetFieldsOnClose}
        />
      </Modal>
    </div>
  );
};

export default ReportExport;
